module.exports = __webpack_public_path__ + "ecb41b4921bddd725ccd6e6da392d985.png";